import { createApp } from 'vue'
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import EventBus from "@/assets/js/event-bus.js"
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faSun } from "@fortawesome/free-solid-svg-icons";
import { faMoon } from "@fortawesome/free-solid-svg-icons";
import { faSmileWink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

import TwitchExt from "@/components/TwitchExt.vue";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { DraggablePlugin } from '@braks/revue-draggable';


library.add(faChartBar);
library.add(faBars);
library.add(faMoon);
library.add(faSmileWink);
library.add(faInfoCircle);
library.add(faSun);

const app = createApp(App);

app.component("font-awesome-icon", FontAwesomeIcon);
app.use(router);
app.use(store);
app.use(BootstrapVue);
app.use(IconsPlugin);
app.component('TwitchExt', TwitchExt)
app.mixin({
  methods: {
    sendEvent: function (category, type, name) {
      if (process.env.NODE_ENV != "production") {
        return;
      }

      ga("send", {
        hitType: "event",
        eventCategory: category,
        eventAction: type,
        eventLabel: name
      });
    },
    notification: function (title, message, delay, append) {
      this.$bvToast.toast(message, {
        title: title,
        toaster: "b-toaster-top-center",
        autoHideDelay: delay,
        appendToast: append
      });
    },
    bitsEnabled: function () {
      return window.Twitch.ext.features.isBitsEnabled;
    }
  }
});
app.config.globalProperties.eventBus = EventBus;
app.use(DraggablePlugin);
router.isReady().then(() => app.mount('#app'))